import axiosInstance from "../config/Axios";

export const searchYoutube = async (query) => {
    const { data } = await axiosInstance.get('/youtube/search', { params: { q: query } });
    return data.data;
};

export const addYoutubeToContent = async (payload) => {
    const { data } = await axiosInstance.post('/youtube/add-to-campaign', payload);
    return data.data;
};
